export const createCompanyMutation = (
    name: string, abbreviation: string, logoUrl: string | null = null, isSilo: boolean = false
) => {
    const args = [
        `name: "${name}"`,
        `abbreviation: "${abbreviation}"`,
    ]
    if (logoUrl) args.push(`logoUrl: "${logoUrl}"`)
    if (isSilo) args.push(`isSilo: ${isSilo}`)

    return `mutation {
        createCompany(${args.join(', ')}) {
            company {
                id
                name
                abbreviation
                logoUrl
                isSilo
            }
        }
    }`
}
